// Method + path patterns that MUST keep working for a migrated (read-only)
// employer. Derived from the service files — see the design doc §7.
// `:id` segments are matched as a single non-slash path segment.

const SAFE_METHODS = new Set(["get", "head", "options"]);

// Endpoints that MUTATE server state despite using GET (an anti-pattern, but
// they exist in this codebase). These must be blocked in read-only mode even
// though they are GETs — otherwise a real write rides the safe-method fast path.
// Verified GET-based mutations (audit `axios.get` across src/features):
const MUTATING_GET_PATTERNS: ReadonlyArray<RegExp> = [
  /^\/document_processing_jobs\/[^/]+\/cancel\/?$/,
  /^\/employee-tickets\/[^/]+\/mark_as_resolved\/?$/,
];

const WRITE_ALLOWLIST: ReadonlyArray<RegExp> = [
  // Auth / session
  /^\/auth\/auth0\/login\/?$/,
  /^\/users\/multi_employer_user\/assign\/?$/,
  // Telemetry (shared axios; blocking these would modal-spam on every page view)
  /^\/analytics\/(identify|track|page)\/?$/,
  // Employee-import file downloads (retrieval only)
  /^\/employeeimportfiles\/[^/]+\/downloadImportFile\/?$/,
  /^\/employeeimportfiles\/[^/]+\/download\/?$/,
  /^\/employeeimportjob\/[^/]+\/download-import-file\/?$/,
  /^\/employeeimportjob\/[^/]+\/download-import-validation-file\/?$/,
  // Reports (separate axios instance; previews + blob generation = reads/exports)
  /^\/api\/reports\//,
  // Read-shaped preview/compute POSTs (no server-side persistence)
  /^\/segments\/[^/]+\/preview\/?$/,
  /^\/segments\/preview-rules\/?$/,
  /^\/mcm-segments\/preview-rules\/?$/,
  /^\/segment-assignments\/preview\/?$/,
  /^\/employertag\/audience-size\/?$/,
  /^\/shift-clocks\/check\/?$/,
];

export const isAllowlisted = (
  method: string | undefined,
  url: string | undefined
): boolean => {
  const verb = (method || "get").toLowerCase();
  const path = (url || "").split("?")[0];
  if (SAFE_METHODS.has(verb)) {
    // Allow real reads, but block GET-shaped mutations (see above).
    return !MUTATING_GET_PATTERNS.some((pattern) => pattern.test(path));
  }
  if (!url) return false;
  return WRITE_ALLOWLIST.some((pattern) => pattern.test(path));
};
